import { PlayCircle } from "@phosphor-icons/react";
import ReactPlayer from "react-player";

export interface VideoOutputOptions {
  controls?: boolean;
  loop?: boolean;
  playing?: boolean;
  showPlayIcon?: boolean;
  className?: string;
}

function DefaultVideoOutput(props: VideoOutputProps) {
  return (
    <div className="h-full relative" data-component="VideoOutput">
      {props.options?.showPlayIcon ? (
        <PlayCircle
          className="absolute top-1 right-1 size-5 p-[1px] z-10 group-hover:opacity-0 group-focus-within:opacity-0 transition-opacity duration-200 bg-r8-gray-1 fill-r8-gray-12 rounded-full"
          weight="light"
        />
      ) : null}
      <ReactPlayer
        playsInline
        onMouseOver={
          !props.options?.controls
            ? (event: any) => {
                if (!event) return;
                try {
                  event.target?.play();
                } catch (e) {
                  console.error(e);
                }
              }
            : undefined
        }
        onMouseOut={
          !props.options?.controls
            ? (event: any) => {
                if (!event) return;
                try {
                  event.target?.pause();
                } catch (e) {
                  console.error(e);
                }
              }
            : undefined
        }
        playing={props.options?.playing}
        muted
        width="100%"
        height="100%"
        src={props.url}
        controls={props.options?.controls}
        loop={props.options?.loop}
        className={props.options?.className}
      />
    </div>
  );
}

interface VideoOutputProps {
  url: string;
  options?: VideoOutputOptions;
}

export function VideoOutput({
  url,
  options = {
    controls: false,
    loop: true,
    playing: false,
    showPlayIcon: false,
  },
}: VideoOutputProps) {
  return <DefaultVideoOutput url={url} options={options} />;
}
